<template>
    <section class="ref-wrapper">

    </section>
</template>

<script>
export default {
    name: 'about-ref',
}
</script>

<style lang="scss">
.ref-wrapper {
    width: 100%;
    height: auto;
}
</style>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
</style>